// MealType will be replaced by official type from SAPI
// https://github.com/FindHotel/sapi/issues/134
export enum MealType {
  Breakfast = 'breakfast',
  Lunch = 'lunch',
  Dinner = 'dinner',
  FullBoard = 'fullBoard',
  HalfBoard = 'halfBoard',
  AllInclusive = 'allInclusive',
  Meals = 'meals'
}

export const getMealsOnly = (services: string[]) => {
  return services.filter(service =>
    Object.values(MealType).includes(service as MealType)
  ) as MealType[]
}
